import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  actionNames,
  eventTypes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import { buttonCss } from "./ChallengesFolderTab.style";

const propTypes = {
  activeTab: PropTypes.string,
  handleOptionSelection: PropTypes.func,
  tabName: PropTypes.string,
};

const ChallengesFolderTab = ({ activeTab, handleOptionSelection, tabName }) => {
  const isSelected = activeTab === tabName;
  const ButtonWithTrackEvent = withTrackEvent(Button);
  const eventProperties = {
    objectType: objectTypes.user,
    actionName: actionNames.interact,
    event_type: eventTypes.click,
    streamProperties: {
      component_type: "ChallengesFolderTab",
      description: `Change Challenge Active Tab to ${tabName} `,
    },
  };

  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: buttonCss(isSelected) }}
      id={`challenge-tab-${tabName}`}
      flavor={isSelected ? "POLAR_SECONDARY" : "TERTIARY"}
      onClick={() => handleOptionSelection(tabName)}
      role="tab"
      {...eventProperties}
      dataProps={{
        "data-qa-selector": `IRC: Change Challenge Active Tab to ${tabName}`,
      }}
    >
      {tabName}
    </ButtonWithTrackEvent>
  );
};

ChallengesFolderTab.propTypes = propTypes;

export default ChallengesFolderTab;
